import React from 'react';

const WithImage = ({ component: Component }) => <Component />;

export default WithImage;
